'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { SearchApiRatingCommentsOrderBy } from '@/app/(main)/(pages)/_types/search-api-response.type';
import { SelectMenu, SelectMenuOption } from '@/components/ui/select-menu/select-menu.component';

export const COMMENTS_SORT_OPTIONS: SelectMenuOption[] = [
  { value: SearchApiRatingCommentsOrderBy.NEWEST, label: 'Mais recentes' },
  { value: SearchApiRatingCommentsOrderBy.OLDEST, label: 'Mais antigos' },
  { value: SearchApiRatingCommentsOrderBy.HIGHEST_RATING, label: 'Maior avaliação' },
  { value: SearchApiRatingCommentsOrderBy.LOWEST_RATING, label: 'Menor avaliação' },
];

interface EntityCommentsSortProps {
  orderBy: SearchApiRatingCommentsOrderBy;
  onOrderByChange: (orderBy: SearchApiRatingCommentsOrderBy) => void;
  disabled?: boolean;
}

export function EntityCommentsSort({ orderBy, onOrderByChange, disabled }: EntityCommentsSortProps) {
  return (
    <SelectMenu
      value={orderBy}
      options={COMMENTS_SORT_OPTIONS}
      onValueChange={(value) => onOrderByChange(value as SearchApiRatingCommentsOrderBy)}
      ariaLabel="Ordenar comentários"
      disabled={disabled}
      dataTestId={DataTestIdEnum.ENTITY_COMMENTS_SORT}
    />
  );
}
